module.exports = __webpack_public_path__ + "img/rank_private_first_class.ed151921.svg";